// extracted by mini-css-extract-plugin
export default {"table":"styles_table__TZLxV","head":"styles_head__IgeT6","body":"styles_body__BDqyl"};